<template>
  <div class="HistoryBlock" v-show="card.history_text.length || showEditLink">
    <div class="Zg">Историческая справка</div>
    <div class="Htxt" v-show="!editMode"><div v-html="card.history_text"></div><div class="EditTxtBt Edit" v-if="showEditLink" @click="toggleEditMode"></div></div>
    <div class="Htxtl" v-show="editMode">
      <Wysiwyg
        :content="card.history_text"
        :saveData="updateHistoryText"
        class="HtxtE"
      ></Wysiwyg>
      <!-- <textarea class='HtxtE' v-model="card.history_text"></textarea><div class="EditTxtBt Add" @click="updateHistoryText"></div> -->
    </div>
  </div>
</template>

<script>
import Wysiwyg from "@/components/Wysiwyg.vue";

export default {
  components: {
    Wysiwyg
  },
  props: {
    card: { type: Object, default: function() { return {}; } },
    showEditLink: { type: Boolean, default: function() { return false; } },
    saveData: Function
  },
  data() {
    return {
      editMode: false
    };
  },
  methods: {
    toggleEditMode() {
      this.editMode = !this.editMode;
      console.log('Card component toggleEditMode', this.editMode);
    },
    updateHistoryText(value) {
      // this.saveData(['history_text'], this.toggleEditMode);
      const params = {history_text: value};
      this.saveData({card: params}, this.toggleEditMode, ['history_text']);
    }
  }
};
</script>
